/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryRegularWithdrawalInstructionsBreakdown
 */
export interface ProposalSummaryRegularWithdrawalInstructionsBreakdown {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRegularWithdrawalInstructionsBreakdown
     */
    assetCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryRegularWithdrawalInstructionsBreakdown
     */
    fundName?: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRegularWithdrawalInstructionsBreakdown
     */
    withdrawalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryRegularWithdrawalInstructionsBreakdown
     */
    withdrawalPercentage?: number;
}

/**
 * Check if a given object implements the ProposalSummaryRegularWithdrawalInstructionsBreakdown interface.
 */
export function instanceOfProposalSummaryRegularWithdrawalInstructionsBreakdown(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProposalSummaryRegularWithdrawalInstructionsBreakdownFromJSON(json: any): ProposalSummaryRegularWithdrawalInstructionsBreakdown {
    return ProposalSummaryRegularWithdrawalInstructionsBreakdownFromJSONTyped(json, false);
}

export function ProposalSummaryRegularWithdrawalInstructionsBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryRegularWithdrawalInstructionsBreakdown {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'fundName': !exists(json, 'FundName') ? undefined : json['FundName'],
        'withdrawalAmount': !exists(json, 'WithdrawalAmount') ? undefined : json['WithdrawalAmount'],
        'withdrawalPercentage': !exists(json, 'WithdrawalPercentage') ? undefined : json['WithdrawalPercentage'],
    };
}

export function ProposalSummaryRegularWithdrawalInstructionsBreakdownToJSON(value?: ProposalSummaryRegularWithdrawalInstructionsBreakdown | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetCode': value.assetCode,
        'FundName': value.fundName,
        'WithdrawalAmount': value.withdrawalAmount,
        'WithdrawalPercentage': value.withdrawalPercentage,
    };
}

